import {track} from '@malt/tracking';

Hop.defineModule('amplitude-tracking-create-account-started-signup-popup', (root) => {
    const url = window.location.href;
    let pageSource: string | undefined;

    // Client Sign-up modal case (eg: unlogged user goes on second page)
    if (url.includes('/s') || url.includes('/all-freelances')) {
        pageSource = 'search';
    } else if (url.includes('/proposal/')) {
        // Malt Open urls are like this :
        // "/proposal/64e4c781e38b271d060891fc?utm_source=mandrill&utm_medium=email&utm_campaign=MaltOpenProposalReceivedEmailV2NoClient"
        pageSource = 'malt_open';
    } else if (url.includes('/company/invite/')) {
        // Company invitation urls are like this :
        // "/company/invite/maltcommunitysa/3d6ce608-f688-44aa-bebc-c84cdd215980/"
        if (url.includes('utm_campaign=StandardInvitationEmail')) {
            pageSource = 'client_invitations_email';
        } else {
            pageSource = 'client_invitations';
        }
    } else if (url.includes('/freelancer-signup/')) {
        pageSource = 'freelancer_signup';
    } else if (url.includes('/t/barometre-tarifs')) {
        pageSource = 'barometer';
    } else {
        pageSource = url;
    }

    track('create_account_started', {
        ...(pageSource ? {page_source: pageSource} : {}),
    });
});
